import React from "react";
import { Box, Typography, Link } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  footer: {
    backgroundColor: "#F6F7FB",
    borderTop: "1px solid rgba(230, 230, 230, 0.5)",
    padding: "40px 20px",
    height: "100px",
  },
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  },
  text: {
    fontFamily: "DM Sans",
    fontSize: "14px",
    lineHeight: "18px",
    color: "#333333",
  },
  link: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "18px",
    color: "#4646b4",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  [theme.breakpoints.down("sm")]: {
    footer: {
      height: "250px",
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <Box component="footer" className={classes.footer}>
      <Box className={classes.content}>
        <Typography className={classes.text}>
          {t("footer.all_rights_reserved")}
        </Typography>

        <Link
          href={`${process.env.REACT_APP_BALTHAUS_URL}/${language}/apsauga/`}
          className={classes.link}
        >
          {t("footer.privacy_policy")}
        </Link>
        <Link
          href={`${process.env.REACT_APP_BALTHAUS_URL}/${language}/pranesimas-apie-asmens-duomenu-tvarkyma`}
          className={classes.link}
        >
          {t("footer.notice_on_personal_data_processing")}
        </Link>
        <Link
          href={`${process.env.REACT_APP_BALTHAUS_URL}/${language}/vaizdo-duomenu-tvarkymo-taisykles`}
          className={classes.link}
        >
          {t("footer.image_data_processing_rules")}
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
